import { observer } from 'mobx-react';
import * as React from 'react';
import { AreaInput, Card, Grid } from 'ui-toolkit';
import { ILegalAndVestingData } from '../../../ui-toolkit/orders/interfaces/titleReport/ILegalAndVesting';

// tslint:disable:jsx-no-lambda TODO: remove this tslint disable

interface IProps {
  data: ILegalAndVestingData;
  error?: any;
  title?: string;
  onFormChange: (dataPath: string, newData: any, error?: string | null | undefined) => void;
  validateFormData: (path: string) => void;
}

export const LegalAndVesting = observer(class LegalAndVesting extends React.Component<IProps, {}> {
  public static defaultProps: Partial<IProps> = {
    title: 'Legal & Vesting',
  };

  public render() {
    return (
      <Card title={this.props.title}>
        <Grid>
          <AreaInput
            value={this.props.data.shortVested}
            errorText={this.props.error['legalAndVesting.shortVested']}
            label="Short vesting info"
            isRequired={true}
            rows={2}
            placeholder="Please add current owner names"
            onChange={(value, error) => this.props.onFormChange('legalAndVesting.shortVested', value, error)}
            onBlur={() => this.props.validateFormData('legalAndVesting.shortVested')}
          />
          <AreaInput
            value={this.props.data.vested}
            errorText={this.props.error['legalAndVesting.vested']}
            label="Currently vested in"
            isRequired={true}
            rows={2}
            placeholder="Please add current owner with any additional clauses"
            onChange={(value, error) => this.props.onFormChange('legalAndVesting.vested', value, error)}
            onBlur={() => this.props.validateFormData('legalAndVesting.vested')}
          />
          <AreaInput
            value={this.props.data.legalDescription}
            errorText={this.props.error['legalAndVesting.legalDescription']}
            label="Legal description"
            rows={4}
            isRequired={true}
            placeholder="Please add Legal description here"
            onChange={(value, error) => this.props.onFormChange('legalAndVesting.legalDescription', value, error)}
            onBlur={() => this.props.validateFormData('legalAndVesting.legalDescription')}
          />
        </Grid>
      </Card>
    );
  }
});
